import { Outlet } from 'react-router-dom';
import { SidebarProvider } from '@ntconsult/aluma-react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { useUIStore } from '@store/uiStore';

export function Layout() {
  const { sidebarOpen, setSidebarOpen } = useUIStore();

  return (
    <div
      className="flex flex-col overflow-hidden bg-surface-raised h-[100dvh] supports-[height:100svh]:h-[100svh]"
      style={{
        paddingTop: 'env(safe-area-inset-top)',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
      }}
    >
      <Header />
      <SidebarProvider
        open={sidebarOpen}
        onOpenChange={setSidebarOpen}
        collapsible="offcanvas"
      >
        <div className="flex flex-1 min-h-0">
          <Sidebar />
          <main
            className="flex-1 min-w-0 overflow-y-auto p-4 sm:p-6"
            style={{ paddingBottom: 'max(env(safe-area-inset-bottom), 1rem)' }}
          >
            <Outlet />
          </main>
        </div>
      </SidebarProvider>
    </div>
  );
}
